import {SystemLabel} from './system-label';
import {Color} from '../../enums/color';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';

export class TcddTrainSystemLabels {
  public [TcddSubSystem.TRACTION_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Green, label: 'normal'},
      {color: Color.Red, label: 'error'}
    ]);

  public [TcddSubSystem.SIGNALIZATION_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Green, label: 'active'},
      {color: Color.Gray, label: 'passive'},
      {color: Color.Yellow, label: 'minorError'},
      {color: Color.Red, label: 'majorError'}
    ]);

  public [TcddSubSystem.COMMUNICATION_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Green, label: 'normal'},
      {color: Color.Red, label: 'error'},
      {color: Color.Pink, label: 'communicationError'}
    ]);

  public [TcddSubSystem.BRAKE_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Gray, label: 'ePBrakeFree'},
      {color: Color.Green, label: 'ePBrakeEngaged'},
      {color: Color.Red, label: 'ePBrakeError'}
    ]);

  public [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Gray, label: 'passive'},
      {color: Color.Green, label: 'active'},
      {color: Color.Orange, label: 'minorError'},
      {color: Color.Red, label: 'majorError'}
    ]);

  public [TcddSubSystem.AIR_CONDITION_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Gray, label: 'passive'},
      {color: Color.Green, label: 'active'},
      {color: Color.Orange, label: 'minorError'},
      {color: Color.Red, label: 'majorError'},
      {color: Color.Pink, label: 'communicationError'}
    ]);

  public [TcddSubSystem.DOOR_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Gray, label: 'doorClosed'},
      {color: Color.Yellow, label: 'doorIsolated'},
      {color: Color.Green, label: 'doorOpen'},
      {color: Color.Blue, label: 'doorActive'},
      {color: Color.Orange, label: 'minorError'},
      {color: Color.Red, label: 'majorError'},
      {color: Color.Pink, label: 'communicationError'}
    ]);

  public [TcddSubSystem.OTHER_SYSTEM]: readonly SystemLabel[] =
    Object.freeze<readonly SystemLabel[]>([
      {color: Color.Gray, label: 'normal'},
      {color: Color.Blue, label: 'active'},
      {color: Color.Yellow, label: 'outOfService'},
      {color: Color.Red, label: 'error'},
      {color: Color.Pink, label: 'communicationError'}
    ]);
}
